export default "__VITE_ASSET__b2pfXU2g__"